import { Box, styled, useTheme } from '@ltvco/refresh-lib/theme';
import { ReportSection } from '@ltvco/refresh-lib/v2';
import { type ReactNode } from 'react';
import { useParams } from 'react-router-dom';

import { CLASS_ACTION_REPORT_CARD_PAD_X } from './constants';

const BlueTopSection = styled(Box)(({ theme }) => ({
  borderRadius: '4px 4px 0 0',
  height: 4,
  width: '100%',
  backgroundColor: theme.palette.primary.main,
}));

export function DesktopReportSection({
  title,
  sectionId,
  children,
}: {
  title: string;
  sectionId: string;
  children: ReactNode;
}) {
  const theme = useTheme();
  const { docketId } = useParams<{ docketId: string }>();

  return (
    <Box sx={{ mb: 2.5 }}>
      <BlueTopSection />
      <ReportSection
        sectionId={sectionId}
        title={title}
        hasContent
        ddReportId={docketId || undefined}
        sx={{
          border: `1px solid ${theme.palette.divider}`,
          borderTop: 'none',
          borderRadius: '0 0 4px 4px',
          bgcolor: theme.palette.common.white,
          overflow: 'hidden',
        }}
        titleSx={{
          fontFamily: `'Nunito Sans', ${theme.typography.fontFamily}`,
          fontSize: 20,
          fontWeight: 700,
          lineHeight: '32px',
          px: CLASS_ACTION_REPORT_CARD_PAD_X,
          pt: 2,
          pb: 1.5,
        }}
      >
        <Box
          sx={{
            px: CLASS_ACTION_REPORT_CARD_PAD_X,
            pt: 1,
            pb: 2,
          }}
        >
          {children}
        </Box>
      </ReportSection>
    </Box>
  );
}
